module.exports = __webpack_public_path__ + "371369f4efe9be9d906182eb5f489fbe.ttf";


//////////////////
// WEBPACK FOOTER
// ./css/fonts/LeagueGothic/leaguegothic-italic-webfont.ttf
// module id = 430
// module chunks = 0